import { Tabs } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { VacationsModel } from 'entities/vacations';
import { VacationArchive } from './vacationArchive';
import { VacationInProgress } from './vacationInProgress';
import { VacationPull } from './vacationPull';
import VacationsSubordinates from './vacationsSubordinates';

import style from './index.module.scss';
import { VacationArchiveOther } from './vacationArchiveOther';
import VacationDownload from './vacationDownload';

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <VacationPull />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine],
  },
  {
    label: 'Подчинённые',
    key: 'other',
    children: <VacationsSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
  {
    label: 'В работе',
    key: 'my',
    children: <VacationInProgress />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine],
  },
  {
    label: 'Архив',
    key: 'myArchive',
    children: <VacationArchive />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine],
  },
  {
    label: 'Архив подчинённых',
    key: 'otherArchive',
    children: <VacationArchiveOther />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
];

export const Vacations = () => {
  const [activeTab, handler] = useTabsNavigate('vacation', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);
  const { vacations: vacationsData } = useAppSelector(VacationsModel.Vacations.selectors.getVacations);
  const { data: vacationListArr } = vacationsData;

  return (
    <>
      <div className={style.vacations__panel}>
        <h3>Отпуск</h3>
        <VacationDownload tabKey={activeTab} disabled={!vacationListArr || vacationListArr?.length < 1} />
      </div>

      <div className={style.wrap}>
        {role && (
          <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
            {tabPane &&
              tabPane.map(el => {
                return (
                  <Tabs.TabPane tab={el.label} key={el.key}>
                    {el.children}
                  </Tabs.TabPane>
                );
              })}
          </Tabs>
        )}
      </div>
    </>
  );
};
